import React from "react";
import { useParams } from "react-router-dom";
import { WaiverSubheader } from "../../waiver-form/WaiverSubheader";
import { WaiverContainer } from "../../waiver-form/WaiverContainer";
import { URLParamsType } from "../../../utils/constants";

interface WaiverWrapperProps {
  waiverDetails: any;
  selectedProgramDetails: any;
  selectedLoan: any;
  getDetails?: () => void;
  callback?: () => void;
}

export const WaiverWrapper = ({
  waiverDetails,
  selectedProgramDetails,
  getDetails,
  selectedLoan,
  callback
}: WaiverWrapperProps) => {
  const { loanStage, loanId } = useParams<URLParamsType>() as any;
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const isLoanding = (val: boolean) => {
    console.log(val);
  };

  return (
    <>
      <WaiverSubheader waiverDetails={waiverDetails} isSelectProgramView />
      <WaiverContainer
        loanStage={loanStage}
        loanId={selectedLoan.value ?? loanId}
        waiverDetails={waiverDetails}
        callbacks={{ isLoading: isLoanding }}
        waiverRequestedInfo={{ isModal: true }}
        getDetails={getDetails}
        takeoutPartnerId={selectedProgramDetails.key}
        callback={callback}
      />
    </>
  );
};
